import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { getPayLaterVendors, getPaymentInfo } from "store/api/pay-with-quickbuck";
import { PaymentInfoProp } from "styles/types/payment";

// import {
//   createVehicleInspection,
//   getVehicleFinfinanceVendors,
//   getVehicleInfo,
// } from "store/api/vehicle-finance";
// import { VehicleInfoProp } from "styles/types/vehicle";
// import { RequestVehicleInspection } from "styles/types/vehicle";

export const getUserPaymentDetail = createAsyncThunk(
  "payment/paymentInfo",
  async (paymentCode:PaymentInfoProp, { rejectWithValue }) => {
    try {
      const response = await getPaymentInfo(paymentCode);
      return response?.data?.Data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (error?.response?.data || error?.message) {
          return rejectWithValue(
            error?.response?.data?.Message || error?.message
          );
        }
      }
    }
  }
);



export const getAllPayLaterVendors = createAsyncThunk(
  "home/payLaterVendors",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getPayLaterVendors();
      return response?.Data.Items;
    } catch (error) {
      if (error instanceof AxiosError)
        if (error?.response?.data || error?.message) {
          return rejectWithValue(
            error?.response?.data?.Message || error?.message
          );
        }
    }
  }
);

type PayLaterVendorState = {
  paymentInfo: any;
  payLaterVendors: any;
  isLoading: boolean;
  error: string | null;
};
const initialState: PayLaterVendorState = {
  isLoading: false,
  error: null,
  paymentInfo: {},
  payLaterVendors: [],
};

const payLaterVendorSlice = createSlice({
  name: "pay-later-vendor",
  initialState: initialState,
  reducers: {},

extraReducers: (builder) => {

  builder.addCase(getUserPaymentDetail.pending, (state) => {
    state.isLoading = true;
    state.error = null;
  });

  builder.addCase(
    getUserPaymentDetail.fulfilled,
    (state, action) => {
      state.isLoading = false;
      state.error = null;
      state.paymentInfo = action.payload;
    }
  );

  builder.addCase(getUserPaymentDetail.rejected, (state, action) => {
    state.isLoading = false;
    if (action.payload) {
      state.error = action.payload as string;
    } else {
      state.error = action.error.message || "Something went wrong";
    }
  });



    builder.addCase(getAllPayLaterVendors.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });

    builder.addCase(getAllPayLaterVendors.fulfilled, (state, action) => {
      state.isLoading = false;
      state.error = null;
      state.payLaterVendors = action.payload;
    });

    builder.addCase(getAllPayLaterVendors.rejected, (state, action) => {
      state.isLoading = false;
      if (action.payload) {
        state.error = action.payload as string;
      } else {
        state.error = action.error.message || "Something went wrong";
      }
    });
  },
});

export default payLaterVendorSlice.reducer;
